module.exports = __webpack_public_path__ + "img/ico-lung-cancer-90-x-90.869da685.svg";